<template>
  <div>
    <div
      v-if="previewVisible"
      class="image-modal-overlay"
      @click.self="closePreview"
    >
      <div class="image-modal">
        <button
          type="button"
          class="close-modal"
          @click="closePreview"
        >
          ×
        </button>
        <div>
          <img
            v-if="!previewImageError"
            :src="previewUrl"
            class="img-fluid"
            alt="Preview"
            @load="onPreviewImageLoad"
            @error="onPreviewImageError"
          >
          <div v-if="previewImageError">
            <p>Arquivo não é uma imagem. <a
              :href="previewUrl"
              target="_blank"
            >Baixar arquivo</a></p>
          </div>
        </div>
        <a
          v-if="previewUrl"
          :href="previewUrl"
          target="_blank"
          class="btn btn-primary mt-2"
        >Baixar Anexo</a>
      </div>
    </div>

    <div
      v-if="approveMultipleModalVisible"
      class="modal fade show"
      tabindex="-1"
      role="dialog"
      style="display: block; background: rgba(0,0,0,0.5);"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Confirmar aprovação
            </h5>
            <button
              type="button"
              class="close"
              @click="closeApproveMultipleModal"
            >
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <p class="mb-0">
              Tem certeza que deseja aprovar
              <strong> {{ selectedCheckRequestIds.length }}</strong>
              solicitações em massa?
            </p>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-back btn-modal-approve"
              @click="closeApproveMultipleModal"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-yes btn-modal-approve"
              :disabled="disabled"
              @click="approveSelectedConfirmed"
            >
              Aprovar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="rejectMultipleModalVisible"
      class="modal fade show"
      tabindex="-1"
      role="dialog"
      style="display: block; background: rgba(0,0,0,0.5);"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Confirmar reprovação
            </h5>
            <button
              type="button"
              class="close"
              @click="closeRejectMultipleModal"
            >
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <p>
              Tem certeza que deseja reprovar
              <strong>{{ selectedCheckRequestIds.length }}</strong>
              solicitações em massa?
            </p>

            <div class="form-group mb-0">
              <label><strong>Justificativa da reprovação <span class="required">*</span></strong></label>
              <textarea
                v-model="bulkApproverJustification"
                class="form-control"
                rows="4"
                placeholder="Informe a justificativa"
              />
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-back btn-modal-approve"
              @click="closeRejectMultipleModal"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-no btn-modal-approve"
              :disabled="disabled"
              @click="rejectSelectedConfirmed"
            >
              Reprovar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Solicitações de marcações pendentes
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-3">
            <input
              v-model="filters.name"
              type="text"
              class="form-control"
              placeholder="Filtrar por nome"
            >
          </div>
          <div class="col-md-2">
            <select
              v-model="filters.department_id"
              class="form-control"
            >
              <option value="">
                Todos Departamentos
              </option>
              <option
                v-for="department in departments"
                :key="department.id"
                :value="department.id"
              >{{
                department.title
              }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <select
              v-model="filters.role_id"
              class="form-control"
            >
              <option value="">
                Todos Cargos
              </option>
              <option
                v-for="role in roles"
                :key="role.id"
                :value="role.id"
              >
                {{ role.title }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <select
              v-model="filters.alocation_id"
              class="form-control"
            >
              <option value="">
                Todas Alocações
              </option>
              <option
                v-for="alocation in alocations"
                :key="alocation.id"
                :value="alocation.id"
              >{{
                alocation.name
              }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <input
              v-model="filters.date"
              type="date"
              class="form-control"
            >
          </div>
        </div>

        <div
          v-if="filtredElements.length && elementsReady"
          class="mt-2"
        >
          <button
            class="btn btn-sm btn-bulk-select mr-2"
            :disabled="disabled"
            @click="selectAllVisible"
          >
            <span v-show="!allVisibleSelected">Selecionar todos</span>
            <span v-show="allVisibleSelected">Desmarcar todos</span>
          </button>

          <button
            v-show="selectedCheckRequestIds.length > 0"
            class="btn btn-sm btn-bulk-approve"
            :disabled="disabled"
            @click="approveSelected"
          >
            Aprovar selecionadas
          </button>

          <button
            v-show="selectedCheckRequestIds.length > 0"
            class="btn btn-sm btn-bulk-decline btn-no-decline ml-2"
            :disabled="disabled"
            @click="openRejectMultipleModal"
          >
            Reprovar selecionadas
          </button>
        </div>
      </div>

      <div
        v-if="loading"
        class="row"
      >
        <div class="col-md-12">
          <div
            class="text-center"
            style="padding: 50px;"
          >
            <div
              class="spinner-border text-primary"
              role="status"
            >
              <span class="sr-only">Carregando solicitações...</span>
            </div>
            <p class="mt-2">
              Carregando solicitações...
            </p>
          </div>
        </div>
      </div>

      <div
        v-if="!loading && checkRequests.length && elementsReady"
        class="row"
      >
        <transition-group
          name="fade"
          tag="div"
          class="w-100"
        >
          <div
            v-for="checkRequest in filtredElements"
            v-if="filtredElements"
            :key="checkRequest.id"
            class="col-md-6 offset-md-3 check-request-card"
          >
            <div class="row mb-3">
              <div class="col-md-1 d-flex align-items-start justify-content-center pt-1">
                <label class="check-request-checkbox">
                  <input
                    v-model="selectedCheckRequestIds"
                    type="checkbox"
                    :value="checkRequest.id"
                    :disabled="disabled || reprovingIds.includes(checkRequest.id)"
                  >
                  <span />
                </label>
              </div>

              <div class="col-md-8 check-request-details">
                <h6>
                  <b>Colaborador: </b>
                  {{ checkRequest.user.name }}
                </h6>
                <h6>
                  <b>Data da solicitação: </b>
                  {{ format(checkRequest.created_at) }}
                </h6>
                <h6>
                  <b>Data e hora: </b>
                  {{ format(checkRequest.datetime) }}
                </h6>
                <h6>
                  <b> Justificativa Colaborador: </b>
                </h6>
                <p>{{ checkRequest.justification }}</p>
                <h6 v-if="checkRequest.downloadFile">
                  <a
                    href="#"
                    @click.prevent="openPreview(checkRequest)"
                  >Visualizar Anexo</a>
                  &nbsp;|&nbsp;
                  <a
                    :href="checkRequest.downloadFile"
                    target="_blank"
                  >Baixar</a>
                </h6>
                <div v-if="reprovingIds.includes(checkRequest.id)">
                  <h6>
                    <b> Justificativa Aprovador: </b>
                  </h6>
                  <textarea
                    v-model="checkRequest.approver_justification"
                    rows="5"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div v-show="!reprovingIds.includes(checkRequest.id)">
                  <button
                    class="btn btn-yes btn-block"
                    :disabled="disabled"
                    @click="approve(2, checkRequest)"
                  >
                    Aprovar
                  </button>
                  <button
                    class="btn btn-no btn-block"
                    :disabled="disabled"
                    @click="justify(checkRequest)"
                  >
                    Reprovar
                  </button>
                </div>
                <div v-show="reprovingIds.includes(checkRequest.id)">
                  <button
                    class="btn btn-yes btn-block"
                    :disabled="disabled"
                    @click="approve(3, checkRequest)"
                  >
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
      <div
        v-if="!loading && !checkRequests.length"
        class="row"
      >
        <div class="col-md-6 offset-md-3">
          <div
            class="alert alert-primary"
            role="alert"
          >
            Nenhuma solicitação pendente!
          </div>
        </div>
      </div>
      <div class="block text-right mb-1">
        <router-link
          to="/checkRequests"
          class="btn btn-back mr-2"
        >
          <i class="fa fa-arrow-left" /> Voltar
        </router-link>
      </div>
      <!-- Pagination -->
      <div
        v-if="pagination.last_page > 1"
        class="row mt-3"
      >
        <div class="col-12 text-center">
          <button
            class="btn btn-sm btn-outline-secondary mr-1"
            :disabled="pagination.current_page <= 1"
            @click="getData(pagination.current_page - 1).then(()=>checkUser())"
          >Anterior
          </button>
          <span> Página {{ pagination.current_page }} de {{ pagination.last_page }} ({{
            pagination.total
          }} registros) </span>
          <button
            class="btn btn-sm btn-outline-secondary ml-1"
            :disabled="pagination.current_page >= pagination.last_page"
            @click="getData(pagination.current_page + 1).then(()=>checkUser())"
          >Próximo
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkRequests: [],
      selectedCheckRequestIds: [],
      reprovingIds: [],
      departments: [],
      roles: [],
      alocations: [],
      filtredElements: [],
      disabled: false,
      loading: false,
      elementsReady: false,
      previewVisible: false,
      approveMultipleModalVisible: false,
      rejectMultipleModalVisible: false,
      bulkApproverJustification: '',
      previewUrl: '',
      previewImageError: false,
      previewImageLoaded: false,
      filters: {
        name: '',
        department_id: '',
        date: '',
        role_id: '',
        alocation_id: '',
      },
      filterTimer: null,
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
      },
    }
  },

  computed: {
    allVisibleSelected() {
      const visibleIds = this.filtredElements
        .filter(checkRequest => !this.reprovingIds.includes(checkRequest.id))
        .map(checkRequest => Number(checkRequest.id))

      const selectedIds = this.selectedCheckRequestIds.map(id => Number(id))

      return visibleIds.length > 0 && visibleIds.every(id => selectedIds.includes(id))
    },
  },

  watch: {
    filters: {
      handler() {
        this.scheduleFilter()
      },
      deep: true,
    },
  },

  async mounted() {
    this.loading = true

    try {
      await Promise.all([
        this.getDepartments(),
        this.getRoles(),
        this.getAlocation(),
      ])

      await this.getData(1)
    } catch (e) {
      console.error(e)
    } finally {
      this.checkUser()
      this.loading = false
    }
  },

  methods: {
    openPreview(checkRequest) {
      const self = this
      if (!checkRequest || !checkRequest.downloadFile) {
        if (self.$message) self.$message('Erro', 'Arquivo não disponível', 'error')
        return
      }
      self.previewUrl = checkRequest.downloadFile
      self.previewImageError = false
      self.previewImageLoaded = false
      self.previewVisible = true
    },

    closePreview() {
      this.previewVisible = false
      this.previewUrl = ''
      this.previewImageError = false
      this.previewImageLoaded = false
    },

    onPreviewImageError() {
      this.previewImageError = true
    },

    onPreviewImageLoad() {
      this.previewImageLoaded = true
    },
    justify(checkRequest) {
      const self = this
      const index = self.reprovingIds.findIndex(x => x == checkRequest.id)
      if (index !== -1) {
        self.reprovingIds.splice(index, 1)
      } else {
        self.reprovingIds.push(checkRequest.id)
      }
    },

    selectAllVisible() {
      const self = this

      const visibleIds = self.filtredElements
        .filter(checkRequest => !self.reprovingIds.includes(checkRequest.id))
        .map(checkRequest => Number(checkRequest.id))

      const selectedIds = self.selectedCheckRequestIds.map(id => Number(id))

      const allSelected = visibleIds.length > 0 && visibleIds.every(id => selectedIds.includes(id))

      if (allSelected) {
        self.selectedCheckRequestIds = selectedIds.filter(id => !visibleIds.includes(id))
      } else {
        self.selectedCheckRequestIds = Array.from(new Set([
          ...selectedIds,
          ...visibleIds,
        ]))
      }
    },

    openApproveMultipleModal() {
      const self = this

      if (!self.selectedCheckRequestIds.length) {
        self.$message('Atenção', 'Selecione pelo menos uma solicitação', 'warning')
        return
      }

      self.approveMultipleModalVisible = true
    },

    approveSelected() {
      const self = this

      if (!self.selectedCheckRequestIds.length) {
        self.$message('Atenção', 'Selecione pelo menos uma solicitação', 'warning')
        return
      }

      self.approveMultipleModalVisible = true
    },

    closeApproveMultipleModal() {
      this.approveMultipleModalVisible = false
    },

    approveSelectedConfirmed() {
      const self = this

      self.approveMultipleModalVisible = false

      if (self.bulkActionStatusId === 3 && !self.bulkApproverJustification.trim()) {
        self.$message('Atenção', 'Informe a justificativa da reprovação', 'warning')
        return
      }

      self.disabled = true
      const api = `${self.$store.state.api}checkrequests/approve-multiple`

      axios
        .post(api, {
          ids: self.selectedCheckRequestIds,
          status_id: 2,
        })
        .then(response => {
          const approvedIds = response.data.approved_ids || self.selectedCheckRequestIds

          self.filtredElements = self.filtredElements.filter(
            checkRequest => !approvedIds.includes(checkRequest.id),
          )

          self.checkRequests = self.checkRequests.filter(
            checkRequest => !approvedIds.includes(checkRequest.id),
          )

          self.selectedCheckRequestIds = []
          self.disabled = false
          self.$message('Sucesso', 'Solicitações aprovadas com sucesso', 'success')
        })
        .catch(error => {
          self.$message('Erro', error.response ? error.response.data : error.message, 'error')
          self.disabled = false
        })
    },

    openRejectMultipleModal() {
      const self = this

      if (!self.selectedCheckRequestIds.length) {
        self.$message('Atenção', 'Selecione pelo menos uma solicitação', 'warning')
        return
      }

      self.bulkApproverJustification = ''
      self.rejectMultipleModalVisible = true
    },

    closeRejectMultipleModal() {
      this.rejectMultipleModalVisible = false
    },

    rejectSelectedConfirmed() {
      const self = this

      if (!self.bulkApproverJustification.trim()) {
        self.$message('Atenção', 'Informe a justificativa da reprovação', 'warning')
        return
      }

      self.rejectMultipleModalVisible = false
      self.disabled = true

      const api = `${self.$store.state.api}checkrequests/approve-multiple`

      axios
        .post(api, {
          ids: self.selectedCheckRequestIds,
          status_id: 3,
          approver_justification: self.bulkApproverJustification,
        })
        .then(response => {
          const processedIds = response.data.processed_ids || response.data.approved_ids || self.selectedCheckRequestIds

          self.filtredElements = self.filtredElements.filter(
            checkRequest => !processedIds.includes(checkRequest.id),
          )

          self.checkRequests = self.checkRequests.filter(
            checkRequest => !processedIds.includes(checkRequest.id),
          )

          self.selectedCheckRequestIds = []
          self.bulkApproverJustification = ''
          self.disabled = false
          self.$message('Sucesso', 'Solicitações reprovadas com sucesso', 'success')
        })
        .catch(error => {
          self.$message('Erro', error.response ? error.response.data : error.message, 'error')
          self.disabled = false
        })
    },

    approve(status_id, checkRequest) {
      const self = this
      self.disabled = true
      const api = `${self.$store.state.api}checkrequests/approve/`
      axios
        .post(api, {
          status_id,
          id: checkRequest.id,
          approver_justification: checkRequest.approver_justification,
        })
        .then(response => {
          const idxFiltered = self.filtredElements.findIndex(el => el.id === checkRequest.id)
          if (idxFiltered !== -1) self.filtredElements.splice(idxFiltered, 1)

          const idxRequests = self.checkRequests.findIndex(el => el.id === checkRequest.id)
          if (idxRequests !== -1) self.checkRequests.splice(idxRequests, 1)

          self.disabled = false
          self.$message('Sucesso', 'Dados registrados com sucesso', 'success')
        })
        .catch(error => {
          self.$message('Erro', error.response.data, 'error')
          self.disabled = false
        })
    },
    format(datetime) {
      return moment(datetime).format('DD/MM/YYYY HH:mm:ss')
    },
    getData(page = 1) {
      const self = this
      self.pagination.current_page = page
      const base = `${self.$store.state.api}checkrequests`
      const params = {
        status_id: 1,
        with: ['user', 'user.alocations'],
        paginated: true,
        page: self.pagination.current_page,
        per_page: self.pagination.per_page,
      }

      if (self.filters.name) params.name = self.filters.name
      if (self.filters.department_id) params.department_id = self.filters.department_id
      if (self.filters.role_id) params.role_id = self.filters.role_id
      if (self.filters.alocation_id) params.alocation_id = self.filters.alocation_id
      if (self.filters.date) params.date = self.filters.date

      return new Promise((resolve, reject) => {
        axios
          .get(base, { params })
          .then(response => {
            const { data } = response
            self.disabled = false
            self.checkRequests = data.data || data
            self.pagination.current_page = data.current_page || 1
            self.pagination.last_page = data.last_page || 1
            self.pagination.per_page = data.per_page || self.pagination.per_page
            self.pagination.total = data.total || (self.checkRequests.length || 0)
            self.disabled = false
            resolve()
          })
          .catch(error => {
            if (self.$swal) {
              self.$swal('Erro', error.response ? JSON.stringify(error.response.data) : error.message, 'error')
            }
            reject(error)
          })
      })
    },
    getDepartments() {
      const self = this
      const api = `${self.$store.state.api}departments`

      return new Promise((resolve, reject) => {
        axios
          .get(api)
          .then(response => {
            self.departments = response.data.data
            resolve()
          })
          .catch(error => {
            self.message('Erro', error.response.data, 'error')
            reject(error)
          })
      })
    },
    getAlocation() {
      const self = this
      const api = `${self.$store.state.api}alocations`

      return new Promise((resolve, reject) => {
        axios
          .get(api)
          .then(response => {
            self.alocations = response.data.data
            resolve()
          })
          .catch(error => {
            self.message('Erro', error.response.data, 'error')
            reject(error)
          })
      })
    },
    getRoles() {
      const self = this
      const api = `${self.$store.state.api}roles/`

      return new Promise((resolve, reject) => {
        axios
          .get(api)
          .then(response => {
            self.roles = response.data.data || []
            resolve()
          })
          .catch(error => {
            self.message('Erro', error.response.data, 'error')
            reject(error)
          })
      })
    },
    resetFilters() {
      this.filters = {
        name: '',
        department_id: '',
        date: '',
        role_id: '',
        alocation_id: '',
      }
      this.pagination.current_page = 1
      Promise.all([this.getDepartments(), this.getRoles(), this.getAlocation()])
        .then(() => this.getData(1).then(() => this.checkUser()))
        .catch(() => this.getData(1).then(() => this.checkUser()))
    },
    scheduleFilter() {
      if (this.filterTimer) clearTimeout(this.filterTimer)
      this.filterTimer = setTimeout(() => {
        this.getData(1).then(() => this.checkUser())
      }, 500)
    },

    checkUser() {
      const self = this
      self.filtredElements = []
      self.elementsReady = false

      if (self.$store.state.user.is_admin === 1) {
        self.filtredElements = self.checkRequests.filter(request => request.user)
        self.elementsReady = true
        return
      }

      if (self.$store.state.user.is_admin === 2) {
        self.filtredElements = self.checkRequests.filter(request => request.user)
        self.elementsReady = true
        return
      }

      if (self.$store.state.user.is_admin === 4) {
        self.filtredElements = self.checkRequests.filter(request => request.user)
        self.elementsReady = true
        return
      }

      self.departments.forEach(department => {
        self.checkRequests.forEach(request => {
          if (request.user && department.id === request.user.department_id) {
            if (department.menager != '') {
              if (self.$store.state.user.id == department.menager) {
                self.filtredElements.push(request)
                self.elementsReady = true
              }
            }
          }
        })
      })
    },
  },
}
</script>

<style scoped>
.check-request-card {
  border-radius: 10px;
  border: 1px solid black;
  margin-bottom: 5px;
  background-color: white;
  padding-top: 10px;
}

.btn-yes {
  border: 1px solid #2ea2cd;
  background-color: white;
  color: #2ea2cd;
}

.btn-yes:hover {
  border-radius: 1px;
  background-color: #2ea2cd;
  color: white;
}

.btn-no {
  border: 1px solid rgb(255, 70, 70);
  background-color: white;
  color: rgb(255, 70, 70);

}

.btn-no:hover {
  border-radius: 1px;
  background-color: rgb(255, 70, 70);
  color: white;
}

.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-leave-to {
  opacity: 0;
}

.image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 20px;
}

.image-modal {
  background: #fff;
  border-radius: 6px;
  max-width: 900px;
  width: 100%;
  padding: 20px;
  position: relative;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
}

.image-modal img {
  display: block;
  max-width: 100%;
  max-height: 80vh;
  margin: 0 auto;
}

.close-modal {
  position: absolute;
  top: 8px;
  right: 10px;
  border: none;
  background: transparent;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
}

.btn-modal-decline {
  border-radius: 8px;
  padding: 8px 22px;
}

.btn-no-decline {
  border: 1px solid rgb(255, 70, 70);
  background-color: white;
  color: rgb(255, 70, 70);
}

.btn-modal-approve {
  border-radius: 8px;
  padding: 8px 22px;
}

.btn-bulk-select {
  border: 1px solid #2ea2cd;
  background-color: transparent;
  color: #2ea2cd;
}

.btn-bulk-select:hover {
  background-color: #2ea2cd;
  color: #ffffff;
}

.btn-bulk-approve {
  border: 1px solid #2ea2cd;
  background-color: #2ea2cd;
  color: #ffffff;
}

.btn-bulk-approve:hover {
  background-color: #2384a8;
  border-color: #2384a8;
  color: #ffffff;
}

.btn-bulk-select:disabled,
.btn-bulk-approve:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.check-request-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 2px 0 0;
  cursor: pointer;
}

.check-request-checkbox input {
  display: none;
}

.check-request-checkbox span {
  width: 16px;
  height: 16px;
  border: 1px solid #2ea2cd;
  border-radius: 3px;
  background: transparent;
  position: relative;
  transition: all 0.15s ease;
}

.check-request-checkbox input:checked + span {
  background: #2ea2cd;
  border-color: #2ea2cd;
}

.check-request-checkbox input:checked + span::after {
  content: "";
  position: absolute;
  left: 4.8px;
  top: 1.5px;
  width: 5px;
  height: 9px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.check-request-checkbox input:disabled + span {
  opacity: 0.45;
  cursor: not-allowed;
}

.required {
  color: #dc3545;
  font-weight: bold;
}

.check-request-details {
  width: 5px;
  padding-top: 10px;
}

.dark-layout .check-request-card {
  background-color: #283046;
  border-color: #3b4253;
  color: #b4b7bd;
}

.dark-layout .check-request-card .btn-yes {
  background-color: transparent;
  border-color: #2ea2cd;
  color: #2ea2cd;
}

.dark-layout .check-request-card .btn-no {
  background-color: transparent;
  border-color: rgb(255, 70, 70);
  color: rgb(255, 70, 70);
}

.dark-layout .image-modal {
  background: #283046;
  color: #b4b7bd;
}

.dark-layout .close-modal {
  color: #b4b7bd;
}
</style>
